import { render } from "./DuoToneTeamingLetterLogo.vue?vue&type=template&id=16077718"
import script from "./DuoToneTeamingLetterLogo.vue?vue&type=script&lang=js"
export * from "./DuoToneTeamingLetterLogo.vue?vue&type=script&lang=js"
script.render = render

export default script